import { FC, ReactNode, useCallback, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { RouteEnum, routes } from '../../settings/routes';
import { useIsLogedInUserAdminMemo, useIsLogedInUserSuperAdminMemo } from '../../utils/rolesUtils';
import { useGetFirstName } from '../../utils/tokenUtils';
import {
	AuthenticityIcon,
	BlogIcon,
	CardIcon,
	CategoriesIcon,
	ConfirmIcon,
	HeritageIcon,
	LogoutIcon,
	MembershipIcon,
	PropertiesIcon,
	UsersIcon,
} from './icons';

type NavItem = {
	route: RouteEnum;
	label: string;
	icon: ReactNode;
	visible: boolean;
};

export const Sidebar: FC = () => {

	const history = useHistory();

	const isUserAdminMemo = useIsLogedInUserAdminMemo();
	const isuserSuperAdminMemo = useIsLogedInUserSuperAdminMemo();

	const firstNameMemo = useGetFirstName();

	const logoutCallback = useCallback(
		() => {
			localStorage.clear();
			history.push(routes[RouteEnum.Login]);
		},
		[history]
	);

	const navItems = useMemo<NavItem[]>(
		() => [
			{
				route: RouteEnum.Blogs,
				label: 'Blog',
				icon: <BlogIcon />,
				visible: true,
			},
			{
				route: RouteEnum.HistoricalHeritage,
				label: 'Istorijsko nasleđe',
				icon: <HeritageIcon />,
				visible: true,
			},
			{
				route: RouteEnum.PPSCards,
				label: 'PPS kartica',
				icon: <CardIcon />,
				visible: true,
			},
			{
				route: RouteEnum.PPSCardMembership,
				label: 'PPS članstvo',
				icon: <MembershipIcon />,
				visible: isUserAdminMemo || isuserSuperAdminMemo,
			},
			{
				route: RouteEnum.Authenticity,
				label: 'Autentičnost zemlje',
				icon: <AuthenticityIcon />,
				visible: true,
			},
			{
				route: RouteEnum.RegistrationConfirm,
				label: 'Objekti za potvrdu',
				icon: <ConfirmIcon />,
				visible: isUserAdminMemo || isuserSuperAdminMemo,
			},
			{
				route: RouteEnum.User,
				label: 'Korisnici',
				icon: <UsersIcon />,
				visible: isuserSuperAdminMemo,
			},
			{
				route: RouteEnum.Categories,
				label: 'Kategorije',
				icon: <CategoriesIcon />,
				visible: isuserSuperAdminMemo,
			},
			{
				route: RouteEnum.PhobsProperties,
				label: 'Phobs objekti',
				icon: <PropertiesIcon />,
				visible: isuserSuperAdminMemo,
			},
		],
		[isUserAdminMemo, isuserSuperAdminMemo]
	);

	const isCurrent = useCallback(
		(route: RouteEnum) => history.location.pathname.includes(routes[route]),
		[history.location.pathname]
	);

	return (
		<aside id='pgside'>
			{/* <div className='pgside-brand'>
				<span className='pgside-brand-mark'>PPS</span>
				<span className='pgside-brand-name'>Admin</span>
			</div> */}

			<div id='pguser'>
				<img src='/potato.png' alt='user-icon' />
				<div className='pguser-meta'>
					<i className='txt'>{firstNameMemo}</i>
					<span className='pguser-role'>
						{isuserSuperAdminMemo ? 'Super admin' : isUserAdminMemo ? 'Admin' : 'Urednik'}
					</span>
				</div>
			</div>

			<span className='pgside-section'>Navigacija</span>

			<nav className='pgside-nav'>
				{navItems.filter(item => item.visible).map(item => (
					<Link
						key={item.route}
						to={routes[item.route]}
						className={isCurrent(item.route) ? 'current' : ''}
					>
						<i className='ico'>{item.icon}</i>
						<i className='txt'>{item.label}</i>
					</Link>
				))}
			</nav>

			<div className='pgside-footer'>
				<Link to='#' onClick={logoutCallback} className='logout-link'>
					<i className='ico'><LogoutIcon /></i>
					<i className='txt'>Odjava</i>
				</Link>
			</div>
		</aside>
	);
};
